export const version = '2.6.0'
